//404ページ
import React, {Component} from 'react';
import Header from './header'
import Footer from './footer'
import {Link} from 'react-router';
import './css/404.css';

export default class error404 extends Component {
  render() {
      return (
    <div id="wrapper">
      <div id="" className="wrapper-lp wrapper-error404">
        <Header/>
        <div className="webWrap">
          <div className="wrapCover">
            <div className="wrapCover__contentBlock clearfix">
              <div className="content-top">
                <div className="block-error404">
                  <h2 className="title">Page Not Found</h2>
                  <img className="title_icon" src="/img/common/404page-item.svg" alt="" />
                  <p className="subtitle">お探しのページが<br />見つかりませんでした</p>
                  <div className="photo-notification">
                  <p>リンクに問題があるか、ページが削除された可能性があります。</p>
                  </div>

                  <div className="btnAction">
                    <Link to="/" className="btn-save">トップページに戻る</Link>
                  </div>
                  
                </div>
              </div>
            </div>
            <Footer/>
          </div>
        </div>
      </div>
    </div>
      )

    }
}



// WEBPACK FOOTER //
// ./src/error404.js